import { Container } from "./styles";

export default function Portfolio() {
  return <Container>Coming Soon</Container>;
}
